// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__2YsQ9","title":"InfoRow_title__2sY_D"};